import type {
  RaspunsBilant,
  SurseDate,
  SursaDate,
} from "@/types/identificareFirma";

export type SurseIntrare = {
  sursa?: SursaDate | null;
  la?: string | null;
  snapshot?: string | null;
  bilant?: RaspunsBilant | null;
  listeVersiune?: string | null;
};

export function buildSurseDate(intrare: SurseIntrare): SurseDate {
  const surse: SurseDate = {};

  if (intrare.sursa) {
    surse.identificare = {
      sursa: intrare.sursa,
      la: intrare.la ?? null,
      snapshot: intrare.snapshot ?? null,
    };
    surse.caen = {
      sursa: intrare.sursa,
      snapshot: intrare.snapshot ?? null,
    };
  }

  const bilant = intrare.bilant;
  if (bilant) {
    const anAles = bilant.ani.find((an) => an.an === bilant.an_recomandat);
    surse.bilant = {
      an: bilant.an_recomandat,
      sursa: bilant.sursa,
      publicat: anAles?.publicat_la ?? null,
    };
  }

  if (intrare.listeVersiune !== undefined) {
    surse.liste = { versiune: intrare.listeVersiune };
  }

  return surse;
}

export function surseDateManuale(): SurseDate {
  return {
    identificare: {
      sursa: "manual",
      la: new Date().toISOString(),
      snapshot: null,
    },
  };
}
